import { lifecycle } from 'recompose'
import Prism from 'prismjs';

export default lifecycle({
  componentDidMount() {
    if (Prism) Prism.highlightAll();
  }
});


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/with-prismjs-hoc.js